<template>
	<v-card class="qr" elevation="10">
		<v-app-bar dark :color="reservedaysData.business.color">
			<v-toolbar-title :style="`color:${reservedaysData.business.btnColor}`">{{ reservedaysData.title }} </v-toolbar-title>
			<v-spacer></v-spacer>
			<v-img max-width="35" contain src="/image/QRIcon.png"> </v-img>
		</v-app-bar>
		<div :class="$vuetify.breakpoint.xs ? 'mx-12 my-7' : 'mx-16 my-7'">
			<div class="text-left mb-7">
				<h2 :style="nowWidth < 425 ? 'font-size: 1em' : 'font-size: 1.2em'" class="QRuser-data">
					<v-layout justify-center>
						<div class="infoBackground" :style="`background-color:${$store.state.PointColor7}`">
							<v-icon size="40px" color="white">mdi-check </v-icon>
						</div>
					</v-layout>
					<div v-if="myData.waitings.length > 0">
						<span class="data">
							[{{ myData.waitings[0].name }}] 고객님 <br />상담신청이 취소되었습니다. <br />
							[카카오 알림톡]을 확인하세요.
						</span>
					</div>
					<div v-else>
						<span class="data">
							상담신청 내역이 존재하지 않습니다.
						</span>
					</div>
				</h2>
				<v-layout class="ma-10">
					<v-flex xs12 class="pr-1"><btn :btn="closeBtn" btn_txt="닫기" @click="close()"></btn></v-flex>
					<a class="hideClose" id="closeWaiting" onclick="window.close(); location.href = 'kakaotalk://inappbrowser/close'; return false;"
						>창 닫기</a
					>
				</v-layout>
			</div>
		</div>
		<v-footer height="25" :color="reservedaysData.business.color"> </v-footer>
	</v-card>
</template>

<script>
import { btn } from '@/components/index.js'
export default {
	components: {
		btn,
	},
	data() {
		return {
			socket: null,
			closeBtn: {
				// 닫기, 상담 취소 버튼
				large: true,
				block: true,
				dark: true,
				class: 'customBtn',
				color: this.$store.state.PointColor1,
			},
			waitLength: 0,
			waitNum: 0,
			screenWidth: 0,
			myData: {
				waitings: [{ name: '', created_at: '', rdate: '' }],
			},
			messageData3: [],
			image: '',
			reservedaysData: {
				business: {
					color: 'black',
				},
			},
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	mounted() {
		this.reservedays()
	},
	methods: {
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		close() {
			//창닫기
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
			document.getElementById('closeWaiting').click()
		},
		sendMessageForCancel(userdata) {
			const rdate = this.$moment(userdata.rdate)
				.subtract('hours', 9)
				.format('YYYY년 MM월 DD일 HH:mm')
			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			if (this.messageData3.message === undefined) {
				// 취소시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData3.message = this.messageData3.message.replace(/#{사업지명}/g, this.reservedaysData.title)
				this.messageData3.message = this.messageData3.message.replace(/#{고객명}/g, this.myData.waitings[0].name)
				this.messageData3.message = this.messageData3.message.replace(/#{예약취소일시}/g, today)
				this.messageData3.message = this.messageData3.message.replace(/#{상담신청일시}/g, rdate)
				this.messageData3.message = this.messageData3.message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
			}
			const buttonsData = JSON.parse(this.messageData3.button)
			buttonsData.forEach(element => {
				element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
				element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
				element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
				element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
				element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.$route.params.phone)
				element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.$route.params.phone)
				element.linkMo = element.linkMo.replace(
					/#{분양정보pdf}/g,
					this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
				)
				element.linkPc = element.linkPc.replace(
					/#{분양정보pdf}/g,
					this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
				)
				if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
					element.linkMo = element.linkMo.replace(
						/#{청약안내pdf}/g,
						this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
					)
					element.linkPc = element.linkPc.replace(
						/#{청약안내pdf}/g,
						this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
					)
				}
				element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
				element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
				element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
				element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
			})
			this.messageData3.button = JSON.stringify(buttonsData)
			const data = {
				// 필수값
				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				tpl_code: this.messageData3.tplCode,
				receiver_1: this.$route.params.phone,
				subject_1: this.messageData3.tplCodeStr,
				message_1: this.messageData3.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.myData.waitings[0].name,
				failover: 'Y',
				fsubject_1: this.messageData3.tplCodeStr,
				fmessage_1: this.messageData3.message,
				button_1: this.messageData3.button ? this.messageData3.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store.dispatch('createSendMessage', data).then(() => {})
		},
		messages(waiting) {
			const data = {}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					let foundIndex3 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.reservedaysData.tplCode[7]
					})
					if (foundIndex3 !== -1) {
						this.messageData3 = res.data.messages[foundIndex3] // delete 알림톡 데이터
						this.sendMessageForCancel(waiting)
					}
				})
				.catch(() => {})
		},
		deleteReserveuser(id, waiting) {
			const data = {
				id: id,

				code: this.$route.params.code,
				custlike: '미처리',
				stat: 2,
			}
			this.$store
				.dispatch('updateWaiting', data)
				.then(() => {
					// this.$socket.emit('reservationBoard', { code: this.$route.params.code })
					// this.$socket.emit('reservation', { code: this.$route.params.code })
					// this.$socket.emit('reservationBoardList', { code: this.$route.params.code })
					this.messages(waiting)
				})
				.catch(() => {})
		},
		reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			this.$store
				.dispatch('reservedays', data)
				.then(res => {
					this.reservedaysData = res.data.reservedays[0]
					this.waitings()
				})
				.catch(() => {})
		},
		waitings() {
			const data = {
				code: this.$route.params.code,
				phone: this.$route.params.phone,
				csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
				cedate:
					this.$moment(new Date())
						.add(1, 'days')
						.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				stat: 0,
			}
			this.$store
				.dispatch('waitings', data)
				.then(res => {
					let sorted = res.data.waitings.sort((a, b) => {
						if (a.id > b.id) return -1
						if (a.id === b.id) return 0
						if (a.id < b.id) return 1
					})
					this.myData.waitings = sorted
					this.deleteReserveuser(sorted[0].id, sorted[0])
				})
				.catch(() => {})
		},
	},
	created() {
		this.screenWidth = window.innerWidth
	},
}
</script>
<style lang="scss">
.infoBackground {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	min-width: 90px;
	min-height: 90px;
	margin-bottom: 10px;
}
.QR-dash {
	width: 100%;
	height: 3px;
	background-image: linear-gradient(to right, #ccc 0%, #ccc 50%, transparent 50%);
	background-size: 10px 2px;
	background-repeat: repeat-x;
}
.QRuser-data {
	letter-spacing: 0.4px !important;
	.QR-title {
		margin-right: 12px;
		font-weight: 400;
		color: #aeaeae !important;
	}
	.data {
		font-weight: 400;
		color: #656565 !important;
	}
}
.v-application--wrap {
	background-color: white !important;
}
.qr {
	border-radius: 16px !important;
	background-color: white;
	max-width: 440px;
	width: 93%;
	margin: 2% auto 2% auto;
	height: auto;
	text-align: center;
}
.qr h1 {
	font-size: 1.7em;
	color: #090909;
	line-height: 2.8em;
	font-weight: 500;
}
.qr h2 {
	font-size: 1.2em;
	color: #898989;
	line-height: 1.5em;
	font-weight: 500;
}
.qr_img {
	width: 100%;
}
.qr_img img {
	transform: scale(1.2);
	width: 100%;
}
.qr_logo {
	max-width: 150px;
	width: 100%;
	margin: 0 auto 0 auto;
}
.qr_logo img {
	width: 100%;
}
.QR-bottomText {
	color: #aeaeae !important;
	letter-spacing: 0.4px !important;
}
</style>
<style lang="scss" scoped>
html,
body,
p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
li,
dl,
dt,
dd,
table,
th,
td,
form,
fieldset,
legend,
input,
textarea,
button {
	font-family: 'Noto Sans KR', 'Apple SD Gothic Neo';
	margin: 0;
	padding: 0;
	letter-spacing: -1px;
}
li {
	list-style: none;
}
img,
fieldset {
	border: none;
	margin: 0;
	padding: 0;
}
</style>
